import {AfterViewInit, Component, OnInit, ChangeDetectorRef, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {forkJoin} from 'rxjs';
import {DataService} from '../../../../Services/data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {EmailModel} from '../../../../DataModels/email-model';
import {RoutingTrackerService} from '../../../../Services/routing-tracker.service';
import {NavigationService} from '../../../../Services/navigation.service';
import {InventoryCountPendingService} from '../../../../Services/inventory-count-pending.service';
import {PendingItem, PendingItemCount} from '../../../../DataModels/inventory-count-pending.model';
import {Modal} from 'bootstrap';

@Component({
  selector: 'app-count-form',
  templateUrl: './count-form.component.html',
  styleUrls: ['./count-form.component.css'],
  standalone: false
})
export class CountFormComponent implements OnInit, AfterViewInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tableDataService: DataService,
    private notification: BsToastService,
    private titleService: Title,
    private confirmDialogService: ConfirmDialogService,
    private cdr: ChangeDetectorRef,
    private prevUrl: RoutingTrackerService,
    private nav: NavigationService,
    private destroyRef: DestroyRef,
    private pendingService: InventoryCountPendingService,
  ) {
    this.vm.title = $localize`:Inventory Counts @@inventoryCounts:Inventory Counts`;
    this.vm.item = {};
    this.vm.tempitems = {};
    this.vm.countSearch = null;
    this.vm.showAdjustmensOnly = false;
    this.vm.systemCount = [];
    this.vm.systemCount.locations = [];
    this.vm.systemCount.locations.items = [];

    // this.vm.countId = this.route.snapshot.params.countId;
    // this.vm.item.countId = this.vm.countId;
  }

  itemBalances = [];
  vm: any = {};
  originalSnapshot: any = null;
  isloaded: boolean;
  submitted = false;
  routedFrom = '';

  buttonConfig: any = {
    save: true,
    close: true,
    reset: false,
    delete: true,
    saveNew: false,
    saveClose: false,
    email: true,
    locked: true,
    print: true,
  };

  buildSnapshot() {
    return JSON.parse(JSON.stringify(this.vm.item ?? {}));
  }

  private setBaseline() {
    this.originalSnapshot = this.buildSnapshot();
  }

  hasChanges(): boolean {
    if (!this.originalSnapshot) {
      return false;
    }
    return JSON.stringify(this.buildSnapshot()) !== JSON.stringify(this.originalSnapshot);
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }

  companyError = false;
  locationError = false;
  countDateError = false;
  categoryError = false;
  countExists = false;
  itemsLoaded = false;

  detTot = 0;

  // Unresolved scans state
  pendingItemCount: PendingItemCount | null = null;
  pendingItems: PendingItem[] = [];
  activeTab: 'countLines' | 'unresolvedScans' = 'countLines';
  selectedPendingItemForMatch: PendingItem | null = null;
  selectedPendingItemForDismiss: PendingItem | null = null;
  dismissNotes: string = '';
  matchSearchText: string = '';
  allCatalogItems: any[] = [];
  allItemsLoaded = false;
  matchingInProgress = false;
  dismissingInProgress = false;

  // Email modal payload holder
  emailObject: EmailModel = new EmailModel();

  ngOnInit() {
    // Ensure form is hidden until we decide what to load
    this.isloaded = false;

    // Track the route we came from to decide how to close
    const prev = this.prevUrl.getPreviousUrl();
    this.routedFrom = prev ? prev : '';

    // Normalize count id from query string and decide new vs existing
    this.vm._countIdEvaluated = false;

    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      if (params.countId === 'new') {
        this.vm.countId = 'new';
        this.pendingItemCount = null;
        this.pendingItems = [];
        // For new counts, there is nothing to fetch; allow the form to render immediately
        this.isloaded = true;
        this.setBaseline();
      } else {
        this.vm.countId = params.countId;
        this.loadExistingCount(params.countId);
      }
      this.vm._countIdEvaluated = true;
    });

    // initialize count as an array to avoid runtime errors when accessing array methods
    this.vm.item.count = [];
    // ensure inventoryItem is always an array, even before initItems() is called
    this.vm.inventoryItem = [];
    // UI-only flag: whether user chose to finalize this count on save
    this.vm.item.finalizeCount = false;
    this.vm.adjustment = {};

    this.vm.showZeroItems = true;
    this.vm.showAdjustments = true;

    this.vm.company = [];
    this.tableDataService
      .getApiListData('company', '?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.company = result.Data;
      });

    this.vm.currency = [];
    this.tableDataService
      .getApiListData('currency', '?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.currency = result;
      });

    this.vm.location = [];
    this.tableDataService
      .getApiListData('location', '?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.location = result.Data;
      });

    this.vm.category = [];
    this.tableDataService
      .getApiListData('item_category', '?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.category = result.Data;
      });
  }

  isFieldEmpty(value: any): boolean {
    let retVal = false;
    if (!value) {
      retVal = true;
    } else {
      retVal = false;
    }
    return retVal;
  }

  initItems(categoryId: string) {
    this.vm.inventoryItem = [];
    this.tableDataService
      .getApiListData('item', '?state=active&pageNumber=0&pageSize=999999&category_id=' + categoryId)
      .subscribe((result: ResponseModel) => {
        const data: any = result.Data;
        this.vm.inventoryItem = data;
        this.itemsLoaded = true;
        // console.log('inventory items which get copied to vm.item.count: ' + JSON.stringify(this.vm.inventoryItem));
      });
    // }
  }

  loadExistingCount(id: string) {
    // console.log('in load existing count - id=: ' + id);
    // Show the form while loading so the UI doesn't appear stuck on header only
    this.isloaded = false;
    this.loadPendingData(id);

    // if (this.vm.countId != 'new') {
    console.log('Fetching count items for countId:', id);
    this.tableDataService.getData('Count', id).subscribe({
      next: (result: any) => {
        // API returns a ResponseModel; the payload is in result.Data
        console.log('Fetched count items result:', result);
        this.vm.item = (result && result.Data) ? result.Data : (result || {});
        // Ensure count is always an array to safely use array methods below
        if (!Array.isArray(this.vm.item?.count)) {
          this.vm.item.count = [];
        }
        this.vm.tempitems = this.vm.item; // for patch compare - don't really need to compare as api will handle

        // format date so datepicker understands
        this.vm.item.count_date = this.vm.item?.count_date ? new Date(this.vm.item.count_date) : new Date();
        this.isloaded = true;
        this.setBaseline();
      },
      error: (_err) => {
        // On error, still allow the form to render so the user isn't blocked
        this.isloaded = true;
      },
    });
  }

  loadPendingData(countId: string) {
    if (!countId || countId === 'new') {
      this.pendingItemCount = null;
      this.pendingItems = [];
      return;
    }
    console.log('Fetching pending item count for countId:', countId);
    this.pendingService.getPendingItemCount(countId).subscribe({
      next: (countRes) => {
        console.log('Fetched pending item count:', countRes);
        this.pendingItemCount = countRes;
        if (countRes && countRes.unresolved > 0) {
          this.loadPendingItems(countId, 'unresolved');
        } else {
          this.pendingItems = [];
        }
      },
      error: (err) => {
        console.error('Error loading pending item counts:', err);
      }
    });
  }

  loadPendingItems(countId: string, status: string = 'unresolved') {
    console.log('Fetching pending (scanned) items for countId:', countId, 'status:', status);
    this.pendingService.getPendingItems(countId, status).subscribe({
      next: (items) => {
        console.log('Fetched pending (scanned) items:', items);
        this.pendingItems = items || [];
      },
      error: (err) => {
        console.error('Error loading pending items:', err);
      }
    });
  }

  getAdjustment(i: any): number {
    // Only compute an adjustment once the user has actually entered a physical count;
    // otherwise an uncounted item would incorrectly show an adjustment equal to -count.
    if (!i || i.physical_count === null || i.physical_count === undefined || i.physical_count === '') {
      return 0;
    }
    const physicalCount = Number(i.physical_count || 0);
    const systemCount = Number(i.count || 0);
    return physicalCount - systemCount;
  }

  clearCountItemsFromUi() {
    this.vm.item.count = [];
  }

  resetUiParamsHaveChanged() {
    this.vm.item.count = [];
    this.countExists = false;
    this.initItems(this.vm.item.category_id);
  }

  checkCountOpen() {
    // refetch zap anything present for items in case user has switched around UI
    const urlParamsJson = {
      // count_date: this.datePipe.transform(this.vm.item.count_date, 'MM/dd/yyyy'),
      count_date: new Date(this.vm.item.count_date).toISOString(),
      company_id: this.vm.item.company_id,
      location_id: this.vm.item.location_id,
      category_id: this.vm.item.category_id,
      // countId: this.vm.countId,
      adjustments_required: false,
      locked: true,
      pageNumber: 0,
      pageSize: 999999,
    };
    const sysCountParam: string = this.encodeQueryData(urlParamsJson);
    this.tableDataService.getApiListData('Count/Open?' + sysCountParam).subscribe((result: ResponseModel) => {
      const data: any = result.Data;
      // console.log('data exists: ' + data.length + ' data:' + JSON.stringify(data)  + ' and id of: ' + this.vm.countId);
      if (data.length > 0 && this.vm.countId === 'new') {
        this.notification.showWarningToast(
          'An open count exists for this company, location, and category. You must complete or delete that count first.'
        );
        this.countExists = true;
        this.clearCountItemsFromUi();
      }
    });
  }

  getSystemCount() {
    if (this.countExists) {
      // console.log('count exist: ' + this.countExists);
      this.countExists = false;
      return;
    } else {
      // For NEW counts, seed the grid from inventory items; for EXISTING counts, DO NOT replace current rows
      if (!this.vm.item?.id) {
        if (!Array.isArray(this.vm.inventoryItem)) {
          this.vm.inventoryItem = [];
        }
        // always assign a safe clone to prevent unexpected mutations
        this.vm.item.count = [...this.vm.inventoryItem];
      }

      this.vm.buttonsDisabled = true;
      const urlParamsJson = {
        count_date: new Date(this.vm.item.count_date).toISOString(),
        company_id: this.vm.item.company_id,
        location_id: this.vm.item.location_id,
        category_id: this.vm.item.category_id,
        pageNumber: 0,
        pageSize: 999999,
      };

      const sysCountParam: string = this.encodeQueryData(urlParamsJson);
      this.tableDataService.getApiListData('count/system?' + sysCountParam).subscribe((result: ResponseModel) => {
        this.vm.systemCount = (result && (result as any).Data) ? (result as any).Data : [];

        // console.log('system count data to mod: ', this.vm.systemCount);

        // item list was pushed over to item.count, by item, above
        // now we have pulled system count data by item so loop thru and populate the fields we need
        // TODO move this to api at some point so we don't need to do this on client.
        const itemsArr: any[] = Array.isArray(this.vm.item.count) ? this.vm.item.count : [];
        const systemArr: any[] = Array.isArray(this.vm.systemCount) ? this.vm.systemCount : [];

        for (let y = 0; y < itemsArr.length; y++) {
          const item = itemsArr[y];
          // ensure object exists before property writes
          if (!item) {
            continue;
          }
          item.count = 0;
          for (let x = 0; x < systemArr.length; x++) {
            const sys = systemArr[x];
            if (sys && sys.item_id == item.id) {
              if (!this.vm.item.id && !item.physical_count) {
                if (sys.count < 0) {
                  item.physical_count = sys.count * -1;
                } else {
                  item.physical_count = sys.count;
                }
              }
              // round to 3 decimals
              item.count = Math.round((sys.count || 0) * 1000) / 1000;
              item.cost = sys.cost;
              break;
            }
          }
        }
        this.vm.buttonsDisabled = false;
        this.notification.showSuccessToast('System Count Loaded / Updated');
      });
    }
  }

  getItemHistory(item_id) {
    this.vm.itemHistoryId = item_id;
    this.vm.itemHistory = [];
    const urlParamsJson = {
      // count_date: this.datePipe.transform(this.vm.item.count_date, 'MM/dd/yyyy'),
      count_date: new Date(this.vm.item.count_date).toISOString(),
      company_id: this.vm.item.company_id,
      location_id: this.vm.item.location_id,
      item_id: item_id,
      pageNumber: 0,
      pageSize: 999999,
    };

    const CountParam: string = this.encodeQueryData(urlParamsJson);
    this.tableDataService.getData('Count/system/history', '?' + CountParam).subscribe((result: ResponseModel) => {
      const data: any = result.Data;
      this.vm.itemHistory = data;
    });
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null && data[d] != '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return ret.join('&');
  }

  errorCheck() {
    this.companyError = !this.vm.item.company_id;
    this.locationError = !this.vm.item.location_id;
    this.countDateError = !this.vm.item.count_date;
    this.categoryError = !this.vm.item.category_id;
  }

  save() {
    // If finalizing, check pending unresolved scans first
    if (this.vm.item.finalizeCount === true) {
      if ((this.pendingItemCount?.unresolved ?? 0) > 0) {
        this.notification.showErrorToast($localize`:Cannot finalize: Unresolved scans exist. Please resolve or dismiss all pending scans before finalizing.:Cannot finalize: Unresolved scans exist. Please resolve or dismiss all pending scans before finalizing.`);
        this.vm.item.finalizeCount = false;
        return;
      }
      const warnings: string[] = [
        'Warning - posting as Finalized locks this count for further counting and posts adjusting entries. Do you wish to proceed?',
        ''
      ];
      const self = this;
      this.confirmDialogService.confirmThis(
        warnings,
        () => {
          self.continueSave(true);
        },
        () => {
          // canceled; do nothing
        }
      );
      return;
    }
    // Non-finalized path
    this.continueSave(false);
  }

  private continueSave(finalize: boolean) {
    if (finalize && (this.pendingItemCount?.unresolved ?? 0) > 0) {
      this.notification.showErrorToast($localize`:Cannot finalize: Unresolved scans exist. Please resolve or dismiss all pending scans before finalizing.:Cannot finalize: Unresolved scans exist. Please resolve or dismiss all pending scans before finalizing.`);
      this.vm.item.finalizeCount = false;
      return;
    }
    const physCountItemExistsCheck = this.vm.item.count.filter((x) => x.physical_count > 0);
    if (physCountItemExistsCheck.length < 1) {
      this.notification.showWarningToast('Cannot save an empty count');
      return;
    }
    this.submitted = true;
    if (
      !this.vm.item.category_id ||
      !this.vm.item.company_id ||
      !this.vm.item.count_date ||
      !this.vm.item.location_id ||
      !this.vm.item.description
    ) {
      this.notification.showWarningToast('Form Errors!');
      return;
    }

    // Ensure API receives adjustment_required only when finalizing
    if (finalize) {
      this.vm.item.adjustment_required = true;
    } else {
      // Avoid persisting UI flag to API payloads
      this.vm.item.adjustment_required = false;
    }

    // Disable buttons while saving
    this.vm.buttonsDisabled = true;

    if (this.vm.item.id === undefined) {
      // Prepare payload for POST
      const payload = {...this.vm.item};
      // UI-only flags should not be sent if API doesn't expect them; keep finalizeCount local
      delete (payload as any).finalizeCount;

      this.tableDataService.post('Count', payload).subscribe({
        next: (item: any) => {
          // Try to normalize id from various possible API shapes
          const newId = item?.id ?? item?.Data?.id;
          if (!newId) {
            // If API didn’t return id for some reason, just re-enable and exit
            this.vm.buttonsDisabled = false;
            return;
          }

          // Update local state with new id
          this.vm.item.id = newId;
          this.vm.countId = newId;

          // If finalized, optimistically lock locally after success
          if (finalize === true) {
            this.vm.item.locked = true;
          }

          // Update URL query param without full navigation and reload record to get server-calculated fields
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {countId: newId},
            queryParamsHandling: 'merge'
          }).then();

          this.loadPendingData(newId);

          // Reload from server to ensure we have latest computed values
          this.tableDataService.getData('Count', newId).subscribe({
            next: (result: any) => {
              this.vm.item = (result && result.Data) ? result.Data : (result || {});
              if (!Array.isArray(this.vm.item?.count)) {
                this.vm.item.count = [];
              }
              // Ensure date type
              this.vm.item.count_date = this.vm.item?.count_date ? new Date(this.vm.item.count_date) : new Date();
              this.isloaded = true;
              this.setBaseline();
            },
            error: () => {
              // on error just re-enable buttons; local state already updated
            },
            complete: () => {
              this.vm.buttonsDisabled = false;
            }
          });
        },
        error: (error: any) => {
          this.vm.buttonsDisabled = false;
          const msg = error?.error?.message ?? error?.error?.error ?? error?.message ?? 'Error saving count';
          this.notification.showErrorToast(msg);
          console.log('post:', error.message);
        }
      });
    } else {
      // diff
      const changes: any = {};

      for (const key in this.vm.item) {
        if (Object.prototype.hasOwnProperty.call(this.vm.item, key)) {
          const value = this.vm.item[key];
          // if (value != this.vm.tempitems[key])
          {
            changes[key] = value;
          }
        }
      }
      // UI-only flag should not be patched
      delete changes.finalizeCount;

      this.tableDataService.patch('Count', this.vm.item.id, changes).then(
        (item: any) => {
          // Normalize id from PATCH response, fallback to current id
          const idFromPatch = item?.id ?? item?.Data?.id ?? this.vm.item.id;
          if (!idFromPatch) {
            this.vm.buttonsDisabled = false;
            return;
          }

          // If finalized, optimistically lock locally after success
          if (finalize === true) {
            this.vm.item.locked = true;
          }

          this.loadPendingData(idFromPatch);

          // Reload current record by id to refresh computed/updated fields
          this.tableDataService.getData('Count', idFromPatch).subscribe({
            next: (result: any) => {
              this.vm.item = (result && result.Data) ? result.Data : (result || {});
              if (!Array.isArray(this.vm.item?.count)) {
                this.vm.item.count = [];
              }
              this.vm.countId = idFromPatch;
              // Ensure date type
              this.vm.item.count_date = this.vm.item?.count_date ? new Date(this.vm.item.count_date) : new Date();
              this.isloaded = true;
              this.setBaseline();
            },
            error: () => {
              // swallow; interceptor handles errors
            },
            complete: () => {
              this.vm.buttonsDisabled = false;
            }
          });
        },
        (error: any) => {
          this.vm.buttonsDisabled = false;
          const msg = error?.error?.message ?? error?.error?.error ?? error?.message ?? 'Error saving count';
          this.notification.showErrorToast(msg);
          console.log('post: ' + error);
        }
      );
    }
  }

  postAdjustment() {
    if (!this.vm.adjustment.detail) {
      this.notification.showInfoToast('No Adjustment Required');
    } else {
      this.vm.buttonsDisabled = true;
      this.tableDataService.post('entry', this.vm.adjustment).subscribe({
        next: (item: any) => {
          // lock if post successful
          this.vm.item.locked = true;
          this.vm.adjustment;
          this.save();
        },
        error: (error) => {
          this.vm.buttonsDisabled = false;
          console.log('post adj: ' + error);
        }
      });
    }
  }

  deleteCount() {
    this.vm.buttonsDisabled = true;
    const countId = this.vm?.item?.id;
    if (!countId) {
      // Nothing to delete
      this.vm.buttonsDisabled = false;
      return;
    }

    // 1) Best-effort unlock before delete so server can clear state
    const preDeletePatch: any = {locked: false, adjustment_required: false};

    const tryDeleteLinkedAdjustment = () => {
      // If the API linked an adjustment/entry id on the count header, try to delete it.
      const anyItem: any = this.vm?.item || {};
      const possibleIds = [
        anyItem.adjustment_entry_id,
        anyItem.entry_id,
        anyItem.header_adjustment_id
      ].filter((v) => !!v);

      if (possibleIds.length > 0) {
        // Use the first id found; ignore errors and continue
        return new Promise<void>((resolve) => {
          this.tableDataService.deleteDataById('entry', possibleIds[0]).subscribe({
            next: () => resolve(),
            error: () => resolve(),
            complete: () => resolve()
          });
        });
      }
      return Promise.resolve();
    };

    // Execute pre-delete steps sequentially but do not block final delete on errors
    const doDelete = () => {
      this.tableDataService.deleteDataById('Count', countId).subscribe(
        (_result: any) => {
          this.vm.buttonsDisabled = false;
          this.router.navigateByUrl('/inventory/count/list').then();
        },
        (_error) => {
          this.vm.buttonsDisabled = false;
          // Log silently; global interceptor handles surfacing
          try {
            console.log('delete: ' + (_error?.description || _error?.message || _error));
          } catch {
          }
        }
      );
    };

    // Start with PATCH unlock
    this.tableDataService.patch('Count', countId, preDeletePatch).then(
      () => {
        tryDeleteLinkedAdjustment().then(() => doDelete());
      },
      () => {
        // Even if unlock fails, still attempt linked adjustment delete and final delete
        tryDeleteLinkedAdjustment().then(() => doDelete());
      }
    );
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.vm.title);
  }

  // Enforce that Finalize cannot be checked for unsaved records or if unresolved scans exist
  onFinalizeChange(checked: boolean) {
    // If user is unchecking, always allow
    if (!checked) {
      this.vm.item.finalizeCount = false;
      return;
    }

    const hasPersistedId = !!this.vm?.item?.id;
    const isNewRoute = this.vm?.countId === 'new' || !this.vm?.countId;

    if (!hasPersistedId || isNewRoute) {
      // Revert the toggle and warn the user
      this.vm.item.finalizeCount = false;
      this.notification.showWarningToast('Record must be saved before finalizing.');
      return;
    }

    if ((this.pendingItemCount?.unresolved ?? 0) > 0) {
      this.vm.item.finalizeCount = false;
      this.notification.showWarningToast('Resolve or dismiss all pending scans before finalizing.');
      return;
    }

    // OK to finalize; keep the checked state
    this.vm.item.finalizeCount = true;
  }

  // Convenience flag to consistently evaluate "new" vs existing
  get isNewCount(): boolean {
    const hasPersistedId = !!this.vm?.item?.id;
    const isNewRoute = this.vm?.countId === 'new' || !this.vm?.countId;
    return !hasPersistedId || isNewRoute;
  }

  // Two-way binding proxy used by Finalize checkbox to always revert when new/unsaved or has unresolved scans
  get finalizeChecked(): boolean {
    // If it's a new count or has unresolved scans, force unchecked visually
    if (this.isNewCount || (this.pendingItemCount?.unresolved ?? 0) > 0) {
      return false;
    }
    return !!this.vm?.item?.finalizeCount;
  }

  set finalizeChecked(val: boolean) {
    if (this.isNewCount) {
      // Always force unchecked and notify
      if (this.vm?.item) {
        this.vm.item.finalizeCount = false;
      }
      this.notification.showWarningToast('Record must be saved before finalizing.');
      // Force UI update in case change detection doesn’t catch it immediately
      try {
        this.cdr.detectChanges();
      } catch {
      }
      return;
    }
    if ((this.pendingItemCount?.unresolved ?? 0) > 0 && val) {
      if (this.vm?.item) {
        this.vm.item.finalizeCount = false;
      }
      this.notification.showWarningToast('Resolve or dismiss all pending scans before finalizing.');
      try {
        this.cdr.detectChanges();
      } catch {
      }
      return;
    }
    if (this.vm?.item) {
      this.vm.item.finalizeCount = !!val;
    }
  }

  // DOM change handler as a backstop to ensure the checkbox flips visually even under quirky detection
  onFinalizeBoxChange(ev: any) {
    const checked = !!ev?.target?.checked;
    if (this.isNewCount) {
      // Force reset
      if (ev?.target) {
        ev.target.checked = false;
      }
      if (this.vm?.item) {
        this.vm.item.finalizeCount = false;
      }
      this.notification.showWarningToast('Record must be saved before finalizing.');
      try {
        this.cdr.detectChanges();
      } catch {
      }
      return;
    }
    if ((this.pendingItemCount?.unresolved ?? 0) > 0 && checked) {
      if (ev?.target) {
        ev.target.checked = false;
      }
      if (this.vm?.item) {
        this.vm.item.finalizeCount = false;
      }
      this.notification.showWarningToast('Resolve or dismiss all pending scans before finalizing.');
      try {
        this.cdr.detectChanges();
      } catch {
      }
      return;
    }
    // Existing record: sync model
    if (this.vm?.item) {
      this.vm.item.finalizeCount = checked;
    }
  }

  finalizeCount() {
    if (this.vm.item.locked) {
      return;
    }
    if ((this.pendingItemCount?.unresolved ?? 0) > 0) {
      this.notification.showWarningToast($localize`:Resolve or dismiss all pending scans before finalizing:Resolve or dismiss all pending scans before finalizing`);
      return;
    }
    this.vm.item.finalizeCount = true;
    this.save();
  }

  openMatchModal(item: PendingItem) {
    this.selectedPendingItemForMatch = item;
    this.matchSearchText = '';
    this.loadCatalogItemsForMatch();
    const modalEl = document.getElementById('matchItemModal');
    if (modalEl) {
      Modal.getOrCreateInstance(modalEl).show();
    }
  }

  closeMatchModal() {
    const modalEl = document.getElementById('matchItemModal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
    this.selectedPendingItemForMatch = null;
    this.matchSearchText = '';
  }

  loadCatalogItemsForMatch() {
    if (this.allItemsLoaded && this.allCatalogItems?.length > 0) {
      return;
    }
    this.tableDataService
      .getApiListData('item', '?state=active&pageNumber=0&pageSize=999999')
      .subscribe({
        next: (result: ResponseModel) => {
          this.allCatalogItems = result.Data || [];
          this.allItemsLoaded = true;
        },
        error: (err) => {
          console.error('Error loading catalog items:', err);
        }
      });
  }

  get filteredCatalogItems(): any[] {
    if (!this.allCatalogItems) {
      return [];
    }
    if (!this.matchSearchText || !this.matchSearchText.trim()) {
      return this.allCatalogItems.slice(0, 50);
    }
    const search = this.matchSearchText.toLowerCase().trim();
    return this.allCatalogItems.filter(item => {
      const code = (item.code || '').toLowerCase();
      const name = (item.name || '').toLowerCase();
      const barcode = (item.barcode || '').toLowerCase();
      const upc = (item.upc || '').toLowerCase();
      return code.includes(search) || name.includes(search) || barcode.includes(search) || upc.includes(search);
    }).slice(0, 50);
  }

  selectItemForMatch(targetItem: any) {
    if (!this.selectedPendingItemForMatch || !targetItem?.id) {
      return;
    }
    // Guard against duplicate/concurrent submissions (e.g. rapid double-click), which would
    // post the same pendingId/itemId pair to the match endpoint more than once; the second
    // call then 404s because the backend already resolved the record from the first call.
    if (this.matchingInProgress) {
      return;
    }
    const countId = this.vm.countId;
    const pendingId = this.selectedPendingItemForMatch.id;
    const barcode = this.selectedPendingItemForMatch.barcode;
    // Resolve ALL unresolved scans that share the same barcode, not just the one clicked,
    // since multiple scans of the same unknown item should resolve together.
    const matchingItems = barcode
      ? this.pendingItems.filter(p => p.barcode === barcode)
      : [this.selectedPendingItemForMatch];
    // De-duplicate ids: the backend has returned duplicate pending records sharing the same id
    // (see NG0955 track-key issue), so mapping matchingItems directly to ids could post the
    // same pendingId/itemId pair to the match endpoint more than once.
    const rawIds = matchingItems.length > 0 ? matchingItems.map(p => p.id) : [pendingId];
    const idsToResolve = Array.from(new Set(rawIds));
    // Sum the scanned quantities of every duplicate-barcode scan being resolved together,
    // so they collapse into a single resolved count line with the combined quantity.
    const totalQtyScanned = matchingItems.reduce((sum, p) => sum + (Number(p.qtyScanned) || 0), 0);
    this.matchingInProgress = true;

    forkJoin(idsToResolve.map(id => this.pendingService.matchPendingItem(countId, id, targetItem.id))).subscribe({
      next: (results: any[]) => {
        this.matchingInProgress = false;
        // Remove all matched barcode items from local unresolved list
        const idSet = new Set(idsToResolve);
        this.pendingItems = this.pendingItems.filter(p => !idSet.has(p.id));
        // Decrement unresolved count by the number of scans just resolved
        if (this.pendingItemCount) {
          this.pendingItemCount.unresolved = Math.max(0, this.pendingItemCount.unresolved - idsToResolve.length);
          this.pendingItemCount.matched = (this.pendingItemCount.matched || 0) + idsToResolve.length;
        }
        // Refresh / append generated count line(s).
        // The match endpoint's response shape can vary (sometimes wrapped in a ResponseModel's
        // `Data` property, sometimes flat), so attempting to merge it locally was unreliable and
        // could silently skip adding the new row (the unresolved badge updates from local state,
        // but the count table wouldn't reflect the new/updated line until a manual refresh).
        // Always re-fetch the authoritative count lines from the server after a successful match
        // so the new/updated row reliably appears without requiring the user to refresh the page.
        let res = results?.[results.length - 1];
        if (res && res.Data) {
          res = res.Data;
        }
        if (res && (res.id || res.item_id) && Array.isArray(this.vm.item.count)) {
          const existingIdx = this.vm.item.count.findIndex((c: any) => (res.id && c.id === res.id) || (res.item_id && c.item_id === res.item_id));
          if (existingIdx >= 0) {
            // Combine with any physical count already on the line (e.g. manual entry) plus the summed scans
            const existingPhysical = Number(this.vm.item.count[existingIdx]?.physical_count) || 0;
            this.vm.item.count[existingIdx] = {
              ...this.vm.item.count[existingIdx],
              ...res,
              physical_count: existingPhysical + totalQtyScanned,
            };
          } else {
            this.vm.item.count = [...this.vm.item.count, {...res, physical_count: totalQtyScanned}];
          }
        }
        // Always reconcile with the server to guarantee the row is present/accurate,
        // even if the optimistic merge above couldn't find a matching line.
        this.reloadCountLines(countId);
        this.notification.showSuccessToast($localize`:Item matched successfully.:Item matched successfully.`);
        this.closeMatchModal();
      },
      error: (err: any) => {
        this.matchingInProgress = false;
        // A 404 here means the backend already resolved this pending record (e.g. it was
        // matched/dismissed by a prior duplicate-barcode call or a previous click), not a
        // real failure. Treat it as already-resolved: drop it locally and re-sync from the
        // server instead of surfacing a scary error toast.
        if (err?.status === 404) {
          const idSet = new Set(idsToResolve);
          this.pendingItems = this.pendingItems.filter(p => !idSet.has(p.id));
          this.loadPendingData(countId);
          this.reloadCountLines(countId);
          this.closeMatchModal();
          return;
        }
        const msg = err?.error?.message ?? err?.error?.error ?? $localize`:Failed to match item:Failed to match item`;
        this.notification.showErrorToast(msg);
      }
    });
  }

  private reloadCountLines(countId: string) {
    if (!countId || countId === 'new') {
      return;
    }
    this.tableDataService.getData('Count', countId).subscribe({
      next: (result: any) => {
        const data = (result && result.Data) ? result.Data : (result || {});
        if (data && Array.isArray(data.count)) {
          this.vm.item.count = data.count;
        }
      }
    });
  }

  openDismissModal(item: PendingItem) {
    this.selectedPendingItemForDismiss = item;
    this.dismissNotes = '';
    const modalEl = document.getElementById('dismissScanModal');
    if (modalEl) {
      Modal.getOrCreateInstance(modalEl).show();
    }
  }

  closeDismissModal() {
    const modalEl = document.getElementById('dismissScanModal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
    this.selectedPendingItemForDismiss = null;
    this.dismissNotes = '';
  }

  confirmDismissScan() {
    if (!this.selectedPendingItemForDismiss) {
      return;
    }
    // Guard against duplicate/concurrent submissions (e.g. rapid double-click), which would
    // post the same pendingId/notes pair to the dismiss endpoint more than once; the second
    // call then 404s because the backend already resolved the record from the first call.
    if (this.dismissingInProgress) {
      return;
    }
    const countId = this.vm.countId;
    const pendingId = this.selectedPendingItemForDismiss.id;
    const barcode = this.selectedPendingItemForDismiss.barcode;
    const notes = this.dismissNotes;
    // Dismiss ALL unresolved scans that share the same barcode, not just the one clicked,
    // since multiple scans of the same unknown item should resolve together.
    const matchingItems = barcode
      ? this.pendingItems.filter(p => p.barcode === barcode)
      : [this.selectedPendingItemForDismiss];
    // De-duplicate ids: the backend has returned duplicate pending records sharing the same id
    // (see NG0955 track-key issue), so mapping matchingItems directly to ids could post the
    // same pendingId/notes pair to the dismiss endpoint more than once.
    const rawIds = matchingItems.length > 0 ? matchingItems.map(p => p.id) : [pendingId];
    const idsToResolve = Array.from(new Set(rawIds));
    this.dismissingInProgress = true;

    forkJoin(idsToResolve.map(id => this.pendingService.dismissPendingItem(countId, id, notes))).subscribe({
      next: (_res: any[]) => {
        this.dismissingInProgress = false;
        // Remove all dismissed barcode items from local unresolved list
        const idSet = new Set(idsToResolve);
        this.pendingItems = this.pendingItems.filter(p => !idSet.has(p.id));
        // Decrement unresolved count by the number of scans just dismissed
        if (this.pendingItemCount) {
          this.pendingItemCount.unresolved = Math.max(0, this.pendingItemCount.unresolved - idsToResolve.length);
          this.pendingItemCount.dismissed = (this.pendingItemCount.dismissed || 0) + idsToResolve.length;
        }
        this.notification.showSuccessToast($localize`:Scan dismissed successfully.:Scan dismissed successfully.`);
        this.closeDismissModal();
      },
      error: (err: any) => {
        this.dismissingInProgress = false;
        // A 404 here means the backend already resolved this pending record (e.g. it was
        // matched/dismissed by a prior duplicate-barcode call or a previous click), not a
        // real failure. Treat it as already-resolved: drop it locally and re-sync from the
        // server instead of surfacing a scary error toast.
        if (err?.status === 404) {
          const idSet = new Set(idsToResolve);
          this.pendingItems = this.pendingItems.filter(p => !idSet.has(p.id));
          this.loadPendingData(countId);
          this.closeDismissModal();
          return;
        }
        const msg = err?.error?.message ?? err?.error?.error ?? $localize`:Failed to dismiss scan:Failed to dismiss scan`;
        this.notification.showErrorToast(msg);
      }
    });
  }

  onClose() {
    const fallback = '/inventory/count/list';
    this.nav.backOr(fallback);
  }

  deleteItem() {
    if (this.vm.countId != 'new') {
      const brClass = this;
      // let retMsg = '';
      const messages: string[] = [
        $localize`:Are you sure you want to delete record? @@areyousureyouwanttodeleterecord:Are you sure you want to delete record?`,
        '',
      ];
      this.confirmDialogService.confirmThis(
        messages,
        () => {
          this.deleteCount();
        },
        () => {
          brClass.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
        }
      );
    }
  }

  locked() {
    if (this.vm.countId != 'new') {
      this.vm.item.locked = true;
      this.save();
    }
  }

  print() {
    try {
      const html = this.buildPrintHtml(false);
      this.printHtmlInIframe(html);
    } catch (e) {
      console.error('Print failed', e);
      // Fallback to browser print of current page
      try {
        window.print();
      } catch {
      }
    }
  }

  // Utility to print HTML in a hidden iframe and clean up afterward
  private printHtmlInIframe(html: string): void {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.setAttribute('aria-hidden', 'true');

    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow?.document as Document | undefined;
    if (!doc) {
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
      return;
    }

    doc.open();
    doc.write(html);
    doc.close();

    const printAndCleanup = () => {
      try {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      } finally {
        setTimeout(() => {
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }
        }, 1000);
      }
    };

    if (doc.readyState === 'complete') {
      setTimeout(printAndCleanup, 250);
    } else {
      iframe.onload = () => setTimeout(printAndCleanup, 250);
    }
  }

  // Wire up to standard send-email-modal process
  emailSend() {
    try {
      const item = this.vm?.item || {};
      const companyName = (this.vm?.company || []).find((c: any) => c.id === item.company_id)?.name || '';
      const locationName = (this.vm?.location || []).find((l: any) => l.id === item.location_id)?.name || '';
      const categoryName = (this.vm?.category || []).find((c: any) => c.id === item.category_id)?.name || '';
      const dateStr = item?.count_date ? new Date(item.count_date).toLocaleDateString() : '';

      // Prefer generated print HTML for better looking email/report
      let pdfHtml = '';
      try {
        pdfHtml = this.buildPrintHtml(true);
      } catch (err) {
        // Fallback to capturing current DOM content if generator fails
        const el = document.getElementById('report-html');
        if (el) {
          pdfHtml = el.innerHTML;
        }
      }

      const fileId = item?.id ?? 'new';
      const safeCompany = (companyName || 'Company').replace(/\s+/g, '_');
      const safeLocation = (locationName || 'Location').replace(/\s+/g, '_');
      const safeCategory = (categoryName || 'Category').replace(/\s+/g, '_');
      const fnameParts = ['InventoryCount', safeCompany, safeLocation, safeCategory, fileId];

      const subjectParts = ['AcctXErp Inventory Count'];
      if (companyName) {
        subjectParts.push(companyName);
      }
      if (locationName) {
        subjectParts.push(locationName);
      }
      if (categoryName) {
        subjectParts.push(categoryName);
      }
      if (dateStr) {
        subjectParts.push(dateStr);
      }

      const emailDocObj = new EmailModel();
      emailDocObj.print_orientation = 'portrait';
      emailDocObj.convert_attachment_to = 'pdf';
      emailDocObj.fromEmail = '';
      emailDocObj.fromName = 'AcctXErp';
      emailDocObj.header_id = item?.id;
      // No specific entity on Counts; include company as context if backend logs it
      emailDocObj.entity_id = item?.company_id;
      emailDocObj.toEmail = '';
      emailDocObj.body = 'Please see the attached Inventory Count.\n\nBest regards,\n\nAcctXErp';
      emailDocObj.Subject = subjectParts.join(' - ');
      emailDocObj.pdfHtml = pdfHtml;
      emailDocObj.activity_message = 'Inventory Count';
      emailDocObj.FileName = fnameParts.filter(Boolean).join('_') + '.pdf';
      emailDocObj.includeAttachment = true;
      emailDocObj.attachment = null;
      emailDocObj.batch_type_id = '' as any; // not applicable for counts

      this.emailObject = emailDocObj;
      // Do not programmatically create/show another modal instance here.
      // The header Email button uses the Bootstrap data-bs-* attributes to open
      // the single shared modal instance rendered in the template.
    } catch (e) {
      console.error('Error preparing email modal for Count:', e);
    }
  }

  // Build a self-contained HTML for printing/emailing the current count
  private buildPrintHtml(forEmail: boolean = false): string {
    const item = this.vm?.item || {};
    const companyName = (this.vm?.company || []).find((c: any) => c.id === item.company_id)?.name || '';
    const locationName = (this.vm?.location || []).find((l: any) => l.id === item.location_id)?.name || '';
    const categoryName = (this.vm?.category || []).find((c: any) => c.id === item.category_id)?.name || '';
    const dateStr = item?.count_date ? new Date(item.count_date).toLocaleDateString() : '';

    const rows: any[] = Array.isArray(item?.count) ? item.count : [];

    const esc = (v: any) => {
      const s = (v == null ? '' : String(v));
      return s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };
    const n = (v: any, digits = 3) => {
      const num = Number(v || 0);
      return num.toLocaleString(undefined, {maximumFractionDigits: digits});
    };

    const headerHtml = `
      <div class="report-header">
        <div><strong>Company:</strong> ${esc(companyName)}</div>
        <div><strong>Location:</strong> ${esc(locationName)}</div>
        <div><strong>Category:</strong> ${esc(categoryName)}</div>
        <div><strong>Date:</strong> ${esc(dateStr)}</div>
        ${item?.description ? `<div style="margin-top:6px"><em>${esc(item.description)}</em></div>` : ''}
        ${item?.locked ? `<div><span class="badge badge-secondary">Locked</span></div>` : ''}
      </div>
    `;

    const bodyRows = rows
      .slice()
      .sort((a: any, b: any) => String(a?.code || '').localeCompare(String(b?.code || '')))
      .map((i: any) => {
        const adjustment = (i?.adjustment ?? (Number(i?.physical_count || 0) - Number(i?.count || 0)));
        const dangerClass = (adjustment || 0) !== 0 ? ' class="text-danger text-bold"' : '';
        return `
          <tr>
            <td><small>${esc(i?.category_name)}</small></td>
            <td>${esc(i?.code)} ${esc(i?.name)}</td>
            <td>${esc(i?.uom_name)}</td>
            <td class="text-right">${n(i?.count)}</td>
            <td class="text-right">${n(i?.physical_count)}</td>
            <td class="text-right"${dangerClass}>${n(adjustment)}</td>
          </tr>
        `;
      })
      .join('');

    const tableHtml = `
      <table class="table table-sm table-bordered table-striped">
        <thead>
          <tr>
            <th>Category</th>
            <th>Item</th>
            <th>UOM</th>
            <th class="text-right">System</th>
            <th class="text-right">Physical</th>
            <th class="text-right">Adjustment</th>
          </tr>
        </thead>
        <tbody>
          ${bodyRows}
        </tbody>
      </table>
    `;

    const styles = `
      <style>
        body { font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: #222; }
        .report-header { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 4px 16px; margin-bottom: 12px; }
        .table { width: 100%; border-collapse: collapse; }
        .table th, .table td { border: 1px solid #ddd; padding: 6px 8px; vertical-align: top; }
        .table thead th { background: #f7f7f7; }
        .text-right { text-align: right; }
        .text-bold { font-weight: bold; }
        .text-danger { color: #b94a48; }
        .badge { display: inline-block; padding: .25em .4em; font-size: 75%; font-weight: 700; line-height: 1; text-align: center; white-space: nowrap; vertical-align: baseline; border-radius: .25rem; }
        .badge-secondary { color: #fff; background-color: #6c757d; }
        @media print { .no-print { display: none !important; } }
      </style>
    `;

    const title = 'Inventory Count';
    const html = `
      <!doctype html>
      <html lang="">
        <head>
          <meta charset="utf-8" />
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <title>${title}</title>
          ${styles}
        </head>
        <body>
          <h2 style="margin-top:0">${esc(title)}</h2>
          ${headerHtml}
          ${tableHtml}
        </body>
      </html>
    `;
    return html;
  }
}
